export default "__VITE_ASSET__$XFEp4k6__"